import { c7Api } from './c7Api';


class AuthMail {
    
    private static instance: AuthMail;
    private baseUrl:string = "api/identificar-mail"

    private constructor() { }

    public static GetInstance(): AuthMail {
        if(!AuthMail.instance){
            AuthMail.instance = new AuthMail();
        }
        return AuthMail.instance;
    }
    
    public async VerificarMail(data:any): Promise<any> {    
      return await c7Api.postFormData(this.baseUrl, data);
    }
}

  export const authMailLogic = AuthMail.GetInstance();